import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {getAll as getEpisodes} from "app/requests/admin/episodes";
import ContentEditor from "components/helpers/form/content-editor";
import {Loading} from "components/pages";
import {useContent} from "lib/hooks";

function AdminPostsForm({onChange, onSubmit, value}) {
  const allPublicTags = useContent("General", "Public Tags").split(", ");
  const [episodes, setEpisodes] = useState(null);
  const publicTags = value("public_tags") || [];
  const onTagChange = (tag, {target: {checked, name}}) => {
    const tags = checked ? [...publicTags, tag] : publicTags.filter((t) => t !== tag);

    onChange({target: {name, value: tags}});
  };

  useEffect(() => {
    getEpisodes().then((data) => setEpisodes(data.episodes));
  }, []);

  if(!episodes) { return <Loading />; }

  return (
    <form onSubmit={onSubmit}>
      <div className="row">
        <div className="col-md-4 offset-md-4">
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <label className="input-group-text" htmlFor="post-episode-id">Episode</label>
            </div>
            <select
              className="form-control"
              id="post-episode-id"
              name="episode_id"
              onChange={onChange}
              required={true}
              value={value("episode_id")}
            >
              <option value="">Select Episode</option>
              {episodes.map(({id, title}) => (
                <option key={id} value={id}>{title}</option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <small className="form-text text-muted mb-3">
              The plain text version of the content (displayed above)
              will be used in places podcast apps and websites don't support html
            </small>
            <ContentEditor
              id="post-content"
              label="Content"
              name="content"
              onChange={onChange}
              value={value("content")}
            />
          </div>
          <div className="mb-3">
            <small className="form-text text-muted mb-3">
              Email content, preview text and subject are all optional
            </small>
            <ContentEditor
              id="post-email-content"
              label="Email Content"
              name="email_content"
              onChange={onChange}
              value={value("email_content")}
            />
          </div>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <label className="input-group-text" htmlFor="post-email-preview-text">Email Preview Text</label>
            </div>
            <textarea
              className="form-control"
              id="post-email-preview-text"
              name="email_preview_text"
              onChange={onChange}
              placeholder="Explore today's case on ultrasounding cat scratches"
              value={value("email_preview_text")}
            />
          </div>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <label className="input-group-text" htmlFor="post-email-subject">Email Subject</label>
            </div>
            <input
              className="form-control"
              id="post-email-subject"
              name="email_subject"
              onChange={onChange}
              placeholder="US GEL - Ouchie"
              type="text"
              value={value("email_subject")}
            />
          </div>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <label className="input-group-text" htmlFor="post-public-tags">Public Tags</label>
            </div>
            <div className="form-control h-auto">
              {allPublicTags.map((tag, index) => (
                <div key={tag} className="custom-control custom-switch">
                  <input
                    checked={publicTags.includes(tag)}
                    className="custom-control-input"
                    id={`post-public-tags-${index}`}
                    name="public_tags"
                    onChange={onTagChange.bind(null, tag)}
                    type="checkbox"
                  />
                  <label className="custom-control-label" htmlFor={`post-public-tags-${index}`}>{tag}</label>
                </div>
              ))}
            </div>
          </div>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <label className="input-group-text" htmlFor="post-tags">Tags</label>
            </div>
            <input
              className="form-control"
              id="post-tags"
              name="tags"
              onChange={onChange}
              placeholder="Tomify, Best Developer, Tired"
              type="text"
              value={value("tags")}
            />
          </div>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <label className="input-group-text" htmlFor="post-title">Title</label>
            </div>
            <input
              className="form-control"
              id="post-title"
              name="title"
              onChange={onChange}
              placeholder="Ultra Sound of Music"
              required={true}
              type="text"
              value={value("title")}
            />
          </div>
          <div className="custom-control custom-switch text-center mb-3">
            <input
              checked={value("disable_comments", false)}
              className="custom-control-input"
              id="episode-disable-comments"
              name="disable_comments"
              onChange={onChange}
              type="checkbox"
            />
            <label className="custom-control-label" htmlFor="episode-disable-comments">Disable Comments</label>
          </div>
          <small className="form-text text-muted mb-3">This will not yet publish your post</small>
          <div className="form-group text-center">
            <button type="submit" className="btn btn-primary">Submit</button>
          </div>
        </div>
      </div>
    </form>
  );
}

AdminPostsForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.func.isRequired
};

export default AdminPostsForm;
